/* eslint-disable max-len */
import React from 'react';

const UploadIcon = props => (
  <svg width={19} height={19} viewBox="0 0 19 19" {...props}>
    <path
      fill="currentColor"
      d="M15 14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2.715c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2V14h9v-2.715c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2V14zm-5-9.177v7.062a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2v-7.05L6.707 7.11a.2.2 0 0 1-.283 0L6 6.685a.2.2 0 0 1 0-.283L9.366 3.06a.2.2 0 0 1 .283 0L13 6.402a.2.2 0 0 1 0 .283l-.424.425a.2.2 0 0 1-.283 0L10 4.823z"
    />
  </svg>
);

export default UploadIcon;
